import React, { useEffect, useState } from "react";
import "./Career.scss";
import PageBanner from "../layouts/PageBanner";
import aboutContact from "../../assets/about-hero.jpg";
import logo from "../../assets/logo.jpg";
import { useNavigate } from "react-router-dom";

const API = "https://api.ainfotech.com.np";

const Career = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/careers?status=open&page=1&limit=12`);
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || "Failed to load careers");

        const mapped = (data.items || []).map((j) => ({
          id: j.slug,
          company: "Avena InfoTech",
          logo: logo,
          title: j.title,
          posted: j.posted_at ? new Date(j.posted_at).toLocaleDateString() : "",
          tags: [j.employment_type, j.level, j.category].filter(Boolean),
          deadline: j.deadline_at ? new Date(j.deadline_at).toLocaleDateString() : "",
        }));

        setJobs(mapped);
      } catch (e) {
        console.error(e);
        setJobs([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="avena-career">
      <PageBanner
        title="Careers"
        bg={aboutContact}
        crumbs={[{ label: "Avena", href: "/" }, { label: "Careers" }]}
      />

      <section className="avena-careers">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="avena-careers__title">
                Featured <span>Jobs</span>
              </h2>
              <p className="avena-careers__lead">
                Explore exciting career opportunities at Avena InfoTech. Check out our featured
                openings and take the next step toward your professional growth today!
              </p>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary mb-3" role="status" />
              <p>Loading job openings...</p>
            </div>
          ) : jobs.length === 0 ? (
            <div className="text-center py-5">
              <h4 className="career-empty__title">No openings at the moment</h4>
             
             
            </div>
          ) : (
            <div className="row g-4">
              {jobs.map((job) => (
                <div className="col-12 col-lg-6" key={job.id}>
                  <article
                    className="avena-job"
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate(`/careers/${job.id}`)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        navigate(`/careers/${job.id}`);
                      }
                    }}
                  >
                    <div className="avena-job__head">
                      <div className="d-flex align-items-center gap-3">
                        <div className="avena-job__logo">
                          <img src={job.logo} alt="Avena InfoTech logo" />
                        </div>
                        <div className="avena-job__meta">
                          <div className="avena-job__company">Avena InfoTech</div>
                          <div className="avena-job__title">
                            <i className="bi bi-briefcase me-2" aria-hidden="true"></i>
                            {job.title}
                          </div>
                          <div className="avena-job__posted">
                            <i className="bi bi-clock me-1" aria-hidden="true"></i>
                            {job.posted}
                          </div>
                        </div>
                      </div>

                      <button
                        className="avena-job__apply"
                        aria-label="Apply"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/careers/${job.id}`);
                        }}
                      >
                        <i className="bi bi-send" aria-hidden="true"></i>
                      </button>
                    </div>

                    <hr className="avena-job__divider" />

                    <div className="avena-job__chips">
                      {job.tags.map((t, i) => (
                        <span className="avena-job__chip" key={i}>
                          {t}
                        </span>
                      ))}
                    </div>

                    <div className="avena-job__footer">
                      <span className="avena-job__deadlineLabel">Deadline:</span>
                      <span className="avena-job__deadline">{job.deadline}</span>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Career;
